// Tendência diária com lacunas quando não há volume apurado.
import {
  ResponsiveContainer, ComposedChart, Area, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
} from 'recharts';
import { SerieDia } from '../types';
import { fmtPct } from '../utils/format';

const C = { atual: '#0078bd', anterior: '#F4364C', grid: '#e6edf4', muted: '#67788e' };

export default function TrendChart({ serie }: { serie: SerieDia[] }) {
  const dados = serie.map((d) => ({
    dia: d.dia,
    atual: d.atual !== null && Number.isFinite(d.atual) ? d.atual * 100 : null,
    anterior: d.anterior !== null && Number.isFinite(d.anterior) ? d.anterior * 100 : null,
  }));
  const valores = dados.flatMap((d) => [d.atual, d.anterior]).filter((v): v is number => v !== null);
  if (!valores.length) return <div className="empty trend-empty" role="status">Ainda não há volume faturado para comparar a tendência.</div>;
  const min = Math.max(0, Math.floor(Math.min(...valores, 100) - 2));
  const max = Math.max(100, Math.ceil(Math.max(...valores)));

  return (
    <div className="trend-chart-shell" role="region" aria-label="Tendência diária de NS Quantidade: mês corrente em azul e mês anterior em vermelho. Dias sem faturamento aparecem como lacunas.">
      <ResponsiveContainer width="100%" height={250}>
        <ComposedChart data={dados} margin={{ top: 10, right: 10, bottom: 0, left: 0 }} accessibilityLayer>
          <CartesianGrid stroke={C.grid} vertical={false} strokeDasharray="3 4" />
          <XAxis dataKey="dia" tick={{ fontSize: 11, fill: C.muted }} tickLine={false} axisLine={{ stroke: C.grid }} interval="preserveStartEnd" minTickGap={22} />
          <YAxis domain={[min, max]} tick={{ fontSize: 11, fill: C.muted }} tickLine={false} axisLine={false} width={44} tickFormatter={(v: number) => `${v}%`} />
          <Tooltip contentStyle={{ fontSize: 12, borderRadius: 12, border: `1px solid ${C.grid}`, boxShadow: '0 6px 24px rgba(0, 51, 93, .1)' }} labelFormatter={(v) => `Dia ${v}`} formatter={(v) => v == null ? '—' : fmtPct(Number(v) / 100)} />
          <Legend wrapperStyle={{ fontSize: 12, paddingTop: 12 }} iconType="circle" iconSize={8} />
          <Area name="Mês anterior" type="monotone" dataKey="anterior" stroke={C.anterior} strokeWidth={1.5} strokeDasharray="4 3" fill={C.anterior} fillOpacity={0.08} isAnimationActive={false} />
          <Line name="Mês corrente" type="monotone" dataKey="atual" stroke={C.atual} strokeWidth={3} dot={false} activeDot={{ r: 5 }} isAnimationActive={false} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
